export default __webpack_public_path__ + "static/media/forestry.7e1c6788.svg";